export default "__VITE_ASSET__2$VNQEh2__"